import React from "react";
import { Link } from "react-router-dom";
import { Facebook, Instagram, Linkedin, Phone, Mail, ShieldCheck, MapPin } from "lucide-react";
import { company, nav } from "../mock/mock";

export default function Footer() {
  const solutions = nav.primary.find((n) => n.children)?.children || [];
  return (
    <footer className="bg-brand-navy text-brand-100">
      <div className="container-x py-14">
        <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <Link to="/" className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-white/10">
                <ShieldCheck className="h-5 w-5 text-brand-teal" />
              </span>
              <span className="text-xl font-bold font-display text-white">
                Verifi<span className="text-brand-300">Assist</span>
              </span>
            </Link>
            <p className="mt-4 text-sm leading-relaxed text-brand-100/70">
              Remote insurance verification, claims and revenue cycle support that helps practices reduce denials and get paid faster — without adding payroll.
            </p>
            <div className="mt-5 flex gap-3">
              <a href={company.socials.facebook} target="_blank" rel="noreferrer" aria-label="Facebook" className="flex h-9 w-9 items-center justify-center rounded-lg bg-white/5 text-brand-100 transition-colors hover:bg-brand-600 hover:text-white"><Facebook className="h-4 w-4" /></a>
              <a href={company.socials.instagram} target="_blank" rel="noreferrer" aria-label="Instagram" className="flex h-9 w-9 items-center justify-center rounded-lg bg-white/5 text-brand-100 transition-colors hover:bg-brand-600 hover:text-white"><Instagram className="h-4 w-4" /></a>
              <a href={company.socials.linkedin} target="_blank" rel="noreferrer" aria-label="LinkedIn" className="flex h-9 w-9 items-center justify-center rounded-lg bg-white/5 text-brand-100 transition-colors hover:bg-brand-600 hover:text-white"><Linkedin className="h-4 w-4" /></a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wide text-white">Solutions</h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              {solutions.map((s) => (
                <li key={s.to}><Link to={s.to} className="text-brand-100/70 transition-colors hover:text-white">{s.label}</Link></li>
              ))}
              <li><Link to="/ar-debt-collections" className="text-brand-100/70 transition-colors hover:text-white">AR & Debt Collections</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wide text-white">Company</h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li><Link to="/" className="text-brand-100/70 transition-colors hover:text-white">Home</Link></li>
              <li><Link to="/pricing" className="text-brand-100/70 transition-colors hover:text-white">Pricing</Link></li>
              <li><Link to="/contact-us" className="text-brand-100/70 transition-colors hover:text-white">Contact Us</Link></li>
              <li><Link to="/hipaa-privacy-policies" className="text-brand-100/70 transition-colors hover:text-white">HIPAA Privacy Policies</Link></li>
              <li><Link to="/privacy-policies" className="text-brand-100/70 transition-colors hover:text-white">Privacy Policy</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wide text-white">Get in touch</h4>
            <ul className="mt-4 space-y-3 text-sm">
              <li><a href={`tel:${company.phoneRaw}`} className="flex items-center gap-2.5 text-brand-100/70 hover:text-white"><Phone className="h-4 w-4 text-brand-teal" /> {company.phone}</a></li>
              <li><a href={`mailto:${company.email}`} className="flex items-center gap-2.5 text-brand-100/70 hover:text-white"><Mail className="h-4 w-4 text-brand-teal" /> {company.email}</a></li>
              <li className="flex items-center gap-2.5 text-brand-100/70"><MapPin className="h-4 w-4 text-brand-teal" /> United States</li>
            </ul>
          </div>
        </div>

        <div className="mt-12 border-t border-white/10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-brand-100/60">
          <p>© {new Date().getFullYear()} {company.legal} — All Rights Reserved.</p>
          <div className="flex gap-5">
            <Link to="/hipaa-privacy-policies" className="hover:text-white">HIPAA</Link>
            <Link to="/privacy-policies" className="hover:text-white">Privacy</Link>
            <Link to="/contact-us" className="hover:text-white">Contact</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
